<script setup lang="ts">
import type { Language } from "../../types/navbar";
import useTracking from "@citizenm/lobby/composables/useTracking";

defineProps<{ languages: Language[] }>();

const route = useRoute();
const { locales, t } = useI18n();

const switchLocalePath = useSwitchLocalePath();
const { trackMainNavi } = useTracking();
</script>

<template>
  <p class="language-switcher__header">
    {{ t("website.navigation.languages.title") }}
  </p>
  <ul>
    <li v-for="locale in locales" :key="locale.code">
      <!--💎-->
      <NuxtLink
        external
        :class="[
          'language-switcher__link',
          route.path.substring(1).startsWith(locale.code) &&
            'language-switcher__link--active',
        ]"
        :to="switchLocalePath(locale.code)"
        @click="trackMainNavi(locale.code)"
      >
        {{ languages.find((lang) => lang.slug === locale.code)?.title }}
      </NuxtLink>
    </li>
  </ul>
</template>

<style scoped lang="scss">
@use "@citizenm/foundation/assets/styles/mixins" as mixins;
@include mixins.reset-list;

.language-switcher {
  &__header {
    color: var(--color-black-pressed, #555);
    font-size: 14px;
  }

  &__link {
    font-weight: bold;
    font-size: 14px;
    line-height: 2.1;
    text-decoration: none;

    &--active,
    &:hover {
      color: var(--primary-red, #ff0038);
    }
  }
}
</style>
